import { SxStyles } from '../../types';
import { getResponsiveSize } from '../../utils';

const mediaBorderRadius = getResponsiveSize(12);

export const ControlPanelFooterSX: SxStyles = {
  footerSx: {
    m: '0 1em',
    ml: '25px',
    pr: '10px',
    '& .content ': {
      '& .client-preview': {
        height: '100%',
        '& .player-container': {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          maxWidth: 'unset',
          minHeight: 'unset',
          height: '100%',
          right: 'unset',
          p: 0,
          '& .player-overlay': {
            position: 'relative',
            height: '85%',
            width: 'auto',
            aspectRatio: '16 / 9',
            maxWidth: '100%',
            margin: 'auto',
            overflow: 'hidden',
            borderRadius: mediaBorderRadius,
            '& .react-player': {
              position: 'absolute',
              inset: 0,
              top: 0,
              minHeight: 'unset',
            },
          },
          '& .player-overlay-image': {
            position: 'relative',
            width: '50%',
            display: 'flex',
            margin: 'auto',
            height: '100%',
            justifyContent: 'center',
            '&::before': {
              content: '""',
              display: 'block',
              paddingTop: '56.25%',
            },
            '& img': {
              position: 'absolute',
              alignSelf: 'center',
              top: '0',
              left: '0',
              width: '100%',
              height: '100%',
              objectFit: 'contain',
              borderRadius: mediaBorderRadius,
            },
          },
        },
        '& .player-container-image': {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          maxWidth: 'unset',
          minHeight: 'unset',
          height: '100%',
          right: 'unset',
          p: 0,
        },
      },
    },
  },
};
